import { useMediaQuery } from "@mui/material";
import React from "react";
import ReactToPdf from "react-to-pdf";
import BasicTable from "../table";

const ref = React.createRef();
const Invoice = ({
  name,
  contact,
  email,
  rate,
  total,
  quantity,
  description,
  accomodation,
  accomodationFee,
}) => {
  let sm = useMediaQuery("(max-width:600px)");

  return (
    <div>
      <ReactToPdf
        targetRef={ref}
        filename="invoice.pdf"
        x={0.5}
        y={0.5}
        scale={0.8}
      >
        {({ toPdf }) => (
          <button
            onClick={toPdf}
            style={{
              background: "#610000",
              outline: "none",
              border: "none",
              borderRadius: 2,
              paddingTop: 8,
              paddingBottom: 8,
              paddingLeft: 16,
              paddingRight: 16,
              color: "white",
              marginBottom: "20px",
              cursor: "pointer",
            }}
          >
            Download Invoice
          </button>
        )}
      </ReactToPdf>
      <div
        style={{
          width: sm ? 370 : 470,
          height: 550,
          background: "white",
          boxShadow: "0px 8px 8px rgba(0, 0, 0, 0.15)",
        }}
        ref={ref}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <img
              src="/assets/navbar/munik-logo.png"
              alt="munik-logo"
              height={sm ? 50 : 80}
              width={sm ? 90 : 130}
              style={{ marginLeft: 20, marginTop: 10 }}
            />
          </div>
          <div style={{ marginRight: 20, marginTop: 10 }}>
            <p style={{ fontSize: "14px" }}>Name: {name}</p>
            <p style={{ fontSize: "14px" }}>Email: {email}</p>
            <p style={{ fontSize: "14px" }}>Contact: {contact}</p>
          </div>
        </div>
        <BasicTable
          description={description}
          quantity={quantity}
          rate={rate}
          accomodation={accomodation}
          accomodationFee={accomodationFee}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            paddingRight: 20,
          }}
        >
          <div>
            <p style={{ fontSize: "14px" }}>Total Amount: {total}</p>
          </div>
        </div>
        <div style={{ marginLeft: 20, marginTop: 10 }}>
          <p style={{ fontSize: "14px" }}>
            <strong>Account Title:</strong> IBA KARACHI (STUDENTS SOCIETIES)
          </p>
          <p style={{ fontSize: "14px" }}>
            <strong>Account No:</strong> 99110107190236
          </p>
          <p style={{ fontSize: "14px" }}>
            <strong>IBAN No:</strong> PK20MEZN0099110107190236
          </p>
          <p style={{ fontSize: "14px" }}>
            <strong>Bank Name:</strong> Meezan Bank Limited
          </p>
        </div>
        <div>
          <p style={{ marginLeft: 20, fontSize: "14px", color: "#525257" }}>
            *This is computer generated invoice no signature required.*
          </p>
        </div>
      </div>
    </div>
  );
};

export default Invoice;
